import { render, staticRenderFns } from "./PreviewElementsManager.vue?vue&type=template&id=3aa4803d&"
import script from "./PreviewElementsManager.vue?vue&type=script&lang=js&"
export * from "./PreviewElementsManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports